var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"checkbox-switch",on:{"click":function($event){$event.stopPropagation();}}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.value},on:{"change":function($event){return _vm.$emit('input', $event.target.checked)}}}),_c('span',{staticClass:"slider round"})])
}
var staticRenderFns = []

export { render, staticRenderFns }